import { queryClient } from '@/shared/api/queryClient';
import { useMediaQuery } from '@/shared/lib/useMediaQuery';

const usePullToRefresh = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleRefresh = async () => {
    await queryClient.invalidateQueries();
  };

  return {
    handleRefresh,
    isMobile,
  };
};

export { usePullToRefresh };
